import { render } from "./AutoCompleteCollaborators.vue?vue&type=template&id=4b7d3741&ts=true"
import script from "./AutoCompleteCollaborators.vue?vue&type=script&lang=ts"
export * from "./AutoCompleteCollaborators.vue?vue&type=script&lang=ts"

import "./AutoCompleteCollaborators.vue?vue&type=style&index=0&id=4b7d3741&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__